import Vue from "vue";

// Components
import FilterBox from "@DigitalCatalogue/Scripts/Components/Catalogue/FilterBox.vue";
import FamilyList from "@DigitalCatalogue/Scripts/Components/Catalogue/FamilyList.vue";

import AddFavorite from "@DigitalCatalogue/Scripts/Components/Favorite/AddFavorite.vue";
import FavoriteList from "@DigitalCatalogue/Scripts/Components/Favorite/FavoriteList.vue";

import SearchBox from "@DigitalCatalogue/Scripts/Components/Search/SearchBox.vue";

import TextureItem from "@DigitalCatalogue/Scripts/Components/Texture/TextureItem.vue";

import DownloadLimitReached from "@DigitalCatalogue/Scripts/Components/Asset/DownloadLimitReached.vue";
import BannerMarketing from "@DigitalCatalogue/Scripts/Components/Asset/BannerMarketing.vue";

import ToastHub from "@Account/Scripts/Components/Toast/ToastHub.vue";

import NewsletterSubscribe from "@Scripts/Components/NewsletterSubscribe/NewsletterSubscribe.vue";
import NewsletterSubscribeCta from "@Scripts/Components/NewsletterSubscribe/NewsletterSubscribeCta.vue";

import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import InfoRequestCta from "@Scripts/Components/InfoRequest/InfoRequestCta.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

import AccountLogout from "@Account/Scripts/Components/Account/AccountLogout.vue";
import AccountUserInfo from "@Account/Scripts/Components/Account/AccountUserInfo.vue";

// Directives
import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("dc-filterbox", FilterBox);
        Vue.component("dc-familylist", FamilyList);

        Vue.component("dc-addfavorite", AddFavorite);
        Vue.component("dc-favoritelist", FavoriteList);

        Vue.component("dc-searchbox", SearchBox);

        Vue.component("dc-textureitem", TextureItem);

        Vue.component("dc-downloadlimitreached", DownloadLimitReached);

        Vue.component("app-toasthub", ToastHub);

        Vue.component("app-newsletter-subscribe", NewsletterSubscribe);
        Vue.component("app-newsletter-subscribe-cta", NewsletterSubscribeCta);

        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-inforequestcta", InfoRequestCta);

        Vue.component("app-cookietoast", CookieToast);

        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountuserinfo", AccountUserInfo);

        Vue.component("app-ctadownload", DownloadLimitReached);
        Vue.component("app-bannermarketing", BannerMarketing);

    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}